var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChcIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7809,
    cy: 26.8123,
    r: 26,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4935 39.1687C35.8496 39.1673 35.2325 38.9109 34.7772 38.4556C34.322 38.0003 34.0656 37.3832 34.0641 36.7393V16.539H38.9229V36.7393C38.9229 37.3836 38.6669 38.0016 38.2113 38.4572C37.7557 38.9128 37.1378 39.1687 36.4935 39.1687Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4935 39.1688C35.8496 39.1674 35.2325 38.911 34.7772 38.4557C34.322 38.0004 34.0656 37.3833 34.0641 36.7395V24.3163H38.9229V36.7395C38.9229 37.3838 38.6669 38.0017 38.2113 38.4573C37.7557 38.9129 37.1378 39.1688 36.4935 39.1688Z",
    fill: "#143A72",
    stroke: "#97144D",
    strokeWidth: 0.22717,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6192 15.359H33.373V17.1292H39.6192V15.359Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.131 39.1687C28.4871 39.1673 27.87 38.9109 27.4147 38.4556C26.9594 38.0003 26.703 37.3832 26.7016 36.7393V16.539H31.5603V36.7393C31.5603 37.3836 31.3044 38.0016 30.8488 38.4572C30.3932 38.9128 29.7753 39.1687 29.131 39.1687Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.131 39.1688C28.4871 39.1674 27.87 38.911 27.4147 38.4557C26.9594 38.0004 26.703 37.3833 26.7016 36.7395V24.3163H31.5603V36.7395C31.5603 37.3838 31.3044 38.0017 30.8488 38.4573C30.3932 38.9129 29.7753 39.1688 29.131 39.1688Z",
    fill: "#143A72",
    stroke: "#97144D",
    strokeWidth: 0.22717,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2567 15.359H26.0106V17.1292H32.2567V15.359Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.377 43.1813L19.1357 43.218L19.2503 34.6124L16.4916 34.5757L16.377 43.1813Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6109 44.7957L19.8685 44.8524L19.8901 43.2312L15.6325 43.1745L15.6109 44.7957Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4231 37.4673L21.2428 37.558L21.4503 21.9679L14.6306 21.8772L14.4231 37.4673Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4108 30.4994L20.4445 30.5664L20.559 21.9608L15.5253 21.8938L15.4108 30.4994Z",
    fill: "#143A72"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4698 36.3586L19.2285 36.3953L19.343 27.7896L16.5843 27.7529L16.4698 36.3586Z",
    fill: "#143A72"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9425 37.4639L21.7349 37.5676L21.7608 35.6168L13.9684 35.5131L13.9425 37.4639Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.025 21.0906L20.0859 21.1447L20.1205 18.5454L16.0596 18.4914L16.025 21.0906Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1419 22.3603L21.9343 22.464L21.9603 20.5132L14.1679 20.4095L14.1419 22.3603Z",
    fill: "#143A72",
    fillOpacity: 0.14
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0219 18.1892L18.1439 8.77222",
    stroke: "#97144D",
    strokeWidth: 0.22717,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChcIcon);
export default __webpack_public_path__ + "static/media/chcIcon.0588230f7611cfc538ddfd3e263b459c.svg";
export { ForwardRef as ReactComponent };